import { Settings } from 'components/Settings.jsx';
import { ChatActions } from 'components/ChatActions.jsx';
import { Html } from 'components/Html.jsx';
import { TokensManager } from 'components/TokensManager.jsx';
import { Request } from 'components/Request.jsx';
import WindowSize from "./WindowSize.jsx";
import { isNetplayPageActive } from 'react/netplay/netplayPageState';

const NotificationManager = function() {
	this.currentTitleAlertLevel = 0;
	this.browserHasFocus = 1;
	this.notification = null;

	this.lastNotificationMessage = null;

	if('serviceWorker' in navigator) {
		navigator.serviceWorker.register(serviceWorkerLocation);
	}
	else {
		console.warn('Service workers aren\'t supported in this browser.');
	}

	this.titleNotification = function(message, duration, level, anyPage = false) {
		//0 = General Chat Messages
		//1 = Subchat message
		//2 =
		//5 = Mentioned
		duration = duration || 0;
		level = level || 0;

		if(level < this.currentTitleAlertLevel) {
			return;
		}


		this.currentTitleAlertLevel = level;
		if(anyPage || isNetplayPageActive()) {
			$.titleAlert(message, {
				requireBlur: true,
				stopOnFocus: true,
				duration: duration,
				interval: 800
			});
		}
	};

	if(typeof document.hasFocus === 'undefined') {
		document.hasFocus = function() {
			return document.visibilityState === 'visible';
		};
	}
	this.checkBrowserFocus = function() {
		this.browserHasFocus = document.hasFocus();
		if(this.browserHasFocus) {
			this.currentTitleAlertLevel = 0;
		}
		return this.browserHasFocus;
	};

	this.showInChatAlso = function(largeScreensAlso) {
		NotificationManager.initializePushNotificationState();
		if(largeScreensAlso || !WindowSize.isMediumOrLarger()) {
			return ChatActions.addNotificationToChat(null, Html.encode(this.lastNotificationMessage));
		}
		return;
	};
	this.clearTag = function(tag) {
		BrowserNotification.messageServiceWorker({ action: 'clearTag', data: { tag: tag } });
	};
	this.showNotification = function(title, options = {}, showAnyway = false) {
		if(!options.body) {
			options.body = '';
		}
		// Off the netplay page notifications stay quiet unless the alert follows
		// the player around the site (the match dock's host code alert).
		const anyPage = !!options.anyPage;
		delete options.anyPage;
		let showTitleNotification = true;
		if(options.showTitleNotification === false) {
			delete options.showTitleNotification;
			showTitleNotification = false;
		}
		this.lastNotificationMessage = options.body;
		if('serviceWorker' in navigator) {
			navigator.serviceWorker.register(serviceWorkerLocation)
				.then(NotificationManager.initializePushNotificationState);
		}
		else {
			console.warn('Service workers aren\'t supported in this browser.');
		}

		if(Settings.isChecked('receive_browser_notifications')) {
			if((!this.checkBrowserFocus() || showAnyway) && (anyPage || isNetplayPageActive())) {
				var defaultOptions = {
					icon: siteUrl + '/general-push-icon-144x144.png',
					timeout: 5500,
					onClick: function() {
						window.focus();
						this.close();
					},
					tag: title,
					serviceWorker: serviceWorkerLocation,
					timestamp: Date.now(),
					title: title
				};

				if(title && showTitleNotification) {
					this.titleNotification(title, 0, 0, anyPage);
				}
				if(options.onClick) {
					var theClick = options.onClick;
					var defaultClick = defaultOptions.onClick;
					delete defaultOptions.onClick;
					delete options.onClick;
					options.onClick = function() {
						theClick.call(this);
						defaultClick.call(this);
					};
				}
				$.extend(defaultOptions, options);
				if(navigator.serviceWorker && navigator.serviceWorker.controller && !options.onClick && options.url) {
					new Promise(function(resolve, reject) {
						// Create a Message Channel
						var msg_chan = new MessageChannel();

						// Handler for recieving message reply from service worker
						msg_chan.port1.onmessage = function(event) {
							if(event.data.error) {
								reject(event.data.error);
							}
							else {
								resolve(event.data);
							}
						};

						// Send message to service worker along with port for reply
						var messageData = {
							action: 'showNotification',
							data: defaultOptions
						};
						navigator.serviceWorker.controller.postMessage(JSON.parse(JSON.stringify(messageData)), [msg_chan.port2]);
					});
				}
				else if(NotificationManager.permissionState() === 'granted') {
					// Push.create would open the browser's permission prompt itself;
					// NotificationPermissionAsk asks first.
					this.notification = Push.create(title, defaultOptions);
				}
			}
		}
		return this;
	};
	return this;
};

NotificationManager.sendSubscriptionToServer = function(subscription) {
	subscription = JSON.parse(JSON.stringify(subscription));
	Request.apiv1('player/push_subscription', subscription)
		.then((response) => {
			console.log('response!');
		})
		.catch((error) => {
			console.log('error...');
			Request.generalJsonError(error);
		})
		.finally(() => {
			console.log('finally!');
		});
	var fetchOptions = {
		method: 'post',
		headers: new Headers({
			'Content-Type': 'application/json'
		}),
		body: JSON.stringify(subscription),
		credentials: 'include'
	};
	// return fetch(siteUrl + '/apiv1/update_push_subscription', fetchOptions);
};

// 'default' (not asked yet), 'granted', 'denied', or 'unsupported'.
NotificationManager.permissionState = function() {
	if(typeof Notification === 'undefined') {
		return 'unsupported';
	}
	return Notification.permission;
};

// Opens the browser's permission prompt. Call it from a click: browsers ignore
// or quietly block permission requests that don't come from a user gesture.
NotificationManager.requestPermissionAndSubscribe = function() {
	if(NotificationManager.permissionState() === 'unsupported') {
		return Promise.resolve('unsupported');
	}
	return Promise.resolve(Notification.requestPermission())
		.then((permission) => {
			if(permission === 'granted') {
				NotificationManager.prototype.subscribe();
			}
			return permission;
		});
};

NotificationManager.pushInitialized = false;
NotificationManager.initializePushNotificationState = function() {
	if(NotificationManager.pushInitialized) {
		return;
	}
	// Subscribing opens the browser's permission prompt while it is undecided,
	// so wait until the player has said yes (see NotificationPermissionAsk).
	if(NotificationManager.permissionState() !== 'granted') {
		return;
	}
	NotificationManager.pushInitialized = true;

	if(!('serviceWorker' in navigator)) {
		console.warn('Service workers aren\'t supported in this browser.');
		return;
	}
	// Are Notifications supported in the service worker?
	if(!('showNotification' in ServiceWorkerRegistration.prototype)) {
		console.warn('Notifications aren\'t supported.');
		return;
	}

	navigator.serviceWorker.addEventListener('message', function(event) {
		console.log(event);
		if(event.data.appCommand) {
			TokensManager.parseData(event.data.appCommand);
		}
		else if(event.data.url) {
			console.error('Unhandled service worker message to post to ' + event.data.url);
		}
	});


	// Check if push messaging is supported
	if(!('PushManager' in window)) {
		console.warn('Push messaging isn\'t supported.');
		return;
	}

	navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
		// Do we already have a push message subscription?
		serviceWorkerRegistration.pushManager.getSubscription()
			.then(function(subscription) {
				if(!subscription) {
					NotificationManager.setButtonToEnable();
					NotificationManager.prototype.subscribe();
					return;
				}

				NotificationManager.sendSubscriptionToServer(subscription);
				NotificationManager.setButtonToDisable();
			})
			.catch(function(err) {
				console.error('Error during getSubscription()', err);
			});
	});
};


function urlB64ToUint8Array(base64String) {
	const padding = '='.repeat((4 - base64String.length % 4) % 4);
	const base64 = (base64String + padding)
		.replace(/\-/g, '+')
		.replace(/_/g, '/');

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for(let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

NotificationManager.setButtonToEnable = function() {
	var button = $('#browser_notifications_general');
	button.prop('checked', false);
};
NotificationManager.setButtonToDisable = function() {
	var button = $('#browser_notifications_general');
	button.prop('checked', true);
};

NotificationManager.prototype.subscribe = function() {
	var applicationServerPublicKey = 'BFbrkG2jtXgwtdorgeFdPG2S+cwP60FjUwJ1voo0RHblreCYzjMGLpm2igdEaJQxBgaIdLvaHibWjQuMHx2cmus=';
	var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

	navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
		serviceWorkerRegistration.pushManager.subscribe({
				userVisibleOnly: true,
				applicationServerKey: applicationServerKey
			})
			.then(function(subscription) {
				NotificationManager.setButtonToDisable();

				return NotificationManager.sendSubscriptionToServer(subscription);
			})
			.catch(function(e) {
				if(Notification.permission === 'denied') {
					// The user denied the notification permission which
					// means we failed to subscribe and the user will need
					// to manually change the notification permission to
					// subscribe to push messages
					console.warn('Permission for Notifications was denied');
				}
				else {
					// A problem occurred with the subscription; common reasons
					// include network errors, and lacking gcm_sender_id and/or
					// gcm_user_visible_only in the manifest.
					console.error('Unable to subscribe to push.', e);
					NotificationManager.setButtonToEnable();
				}
			});
	});
};

NotificationManager.prototype.unsubscribe = function() {
	navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
		// To unsubscribe from push messaging, you need get the
		// subscription object, which you can call unsubscribe() on.
		serviceWorkerRegistration.pushManager.getSubscription().then(
			function(pushSubscription) {
				// Check we have a subscription to unsubscribe
				if(!pushSubscription) {
					button.prop('disabled', false);
					NotificationManager.setButtonToEnable();
					return;
				}

				var subscriptionId = pushSubscription.subscriptionId;
				// TODO: Make a request to your server to remove
				// the subscriptionId from your data store so you
				// don't attempt to send them push messages anymore

				// We have a subscription, so call unsubscribe on it
				pushSubscription.unsubscribe().then(function(successful) {
					NotificationManager.setButtonToEnable();
				}).catch(function(e) {

					console.log('Unsubscription error: ', e);
					NotificationManager.setButtonToEnable();
				});
			}).catch(function(e) {
			console.error('Error thrown while unsubscribing from push messaging.', e);
		});
	});
};


const BrowserNotification = new NotificationManager();
BrowserNotification.permissionState = NotificationManager.permissionState;
BrowserNotification.requestPermissionAndSubscribe = NotificationManager.requestPermissionAndSubscribe;
export { BrowserNotification, NotificationManager };